import React from 'react';

import Box from '@mui/material/Box';

import { useResponsive } from '../../../../hooks';

import { useCookieConsent } from '../../hooks';

interface BannerHeights {
  DESKTOP: string;
  MOBILE: string;
}

interface CookieOffsetBoxProps {
  children: React.ReactNode;
  bannerHeights: BannerHeights;
}

const CookieOffsetBox: React.FC<CookieOffsetBoxProps> = ({ children, bannerHeights }) => {
  const { shouldDisplayCookieBanner } = useCookieConsent();
  const smDown = useResponsive('down', 'sm');

  return (
    <Box
      sx={{
        // Offset the app below the fixed banner with padding, not margin: a top margin collapses
        // up through #root (height: 100%), pushing the whole root down and overflowing the page by
        // the banner height. Padding stays inside the box (border-box), so 100vh is exact.
        ...(!shouldDisplayCookieBanner
          ? {}
          : {
              pt: smDown ? bannerHeights.MOBILE : bannerHeights.DESKTOP,
            }),
        minHeight: '100vh',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      {children}
    </Box>
  );
};

export default CookieOffsetBox;
